<template>
  <div></div>
</template>
<script>
import { get } from 'lodash'
import { ShortcutService } from '@/common/api/api.service'
import { parseUrl, stringify } from 'query-string'
export default {
  name: 'ShortCutSns',
  created () {
    const pincode = get(this.$route, ['query', 'pincode'], '')
    if (pincode === '') {
      alert('pincode 를 확인 하세요')
      return
    }
    ShortcutService.getFullUrlByPincode({ pincode: pincode }).then(({ data }) => {
      const resUrl = get(data, 'url', '')
      const { url, query } = parseUrl(resUrl)
      query.pincode = pincode
      if (url !== '') {
        location.replace(`${url}?${stringify(query)}`)
      }
    })
  }
}
</script>
